import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { IconChevronLeft } from '@calendly/ui/components/glyphs/IconChevronLeft';
import { Popup, Header, Title, Body, Footer } from '@calendly/ui/components/popup';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { sortBy } from 'lodash-es';
import { useMemo, useState, forwardRef } from 'react';
import { Member } from './member';
const backButtonCss = "b4o3m6c";
const BackButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(backButtonCss, props.className)} />);
const blockCss = "bd25wps";
const Block = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(blockCss, props.className)} />;
});
const sortMemberships = (memberships, originalUserUUID) => sortBy(memberships, membership => {
  // selectable, originally assigned first
  if (membership.enabled && membership.user_uuid === originalUserUUID) return 1;

  // followed by other selectables
  if (membership.enabled) return 2;

  // remaining
  return 3;
});
const initialSelectedUserUUID = (memberships, originalUserUUID) => {
  const exists = memberships.some(membership => membership.user_uuid === originalUserUUID && membership.enabled === true);
  return exists ? originalUserUUID : null;
};
export const ChooseMemberModal = ({
  event,
  onBack,
  onSelect,
  onClose
}) => {
  const originalUserUUID = event.pageMembers[0].uuid;
  const memberships = event.eventType.memberships.filter(membership => !event.collectiveMembersUuids.includes(membership.userUuid));
  const sortedMemberships = useMemo(() => sortMemberships(memberships, originalUserUUID), [memberships, originalUserUUID]);
  const [selectedUserUUID, selectUserUUID] = useState(initialSelectedUserUUID(memberships, originalUserUUID));
  return <Popup isOpen onClose={onClose}>
      <Header>
        <BackButton tooltip={I18n.t('publisher.action.back')} onClick={onBack}>
          <UiIcon icon={IconChevronLeft} size="medium" />
        </BackButton>
        <Title>
          {I18n.t('publisher.dashboard.event.choose_team_member_title')}
        </Title>
      </Header>
      <Body>
        <Block>
          {I18n.t('publisher.dashboard.event.notified_parties')}
        </Block>
        <div data-component="member-list">
          {sortedMemberships.map(membership => <Member key={membership.id} membership={membership} originalUserUUID={originalUserUUID} selectedUserUUID={selectedUserUUID} onClick={() => selectUserUUID(membership.userUuid)} />)}
        </div>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button disabled={!selectedUserUUID} onClick={() => onSelect(selectedUserUUID)}>
          {I18n.t('publisher.dashboard.event.select_time')}
        </Button>
      </Footer>
    </Popup>;
};

require("./choose_member_modal.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./choose_member_modal.js");